module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page__hd"
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "page__desc"
  }, [_vm._v(_vm._s(_vm.desc))])]), _vm._v(" "), _vm._m(0, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__bd"
  }, [_c('article', {
    staticClass: "weui-article"
  }, [_c('h1', [_vm._v("大标题")]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "title"
  }, [_vm._v("章标题")]), _vm._v(" "), _c('section', [_c('h3', [_vm._v("1.1 节标题")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n\t\t\t\t\t\ttempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n\t\t\t\t\t\tquis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n\t\t\t\t\t\tconsequat.\n\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/logo.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/logo.jpg"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('section', [_c('h3', [_vm._v("1.2 节标题")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n\t\t\t\t\t\ttempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n\t\t\t\t\t\tcillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n\t\t\t\t\t\tproident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n\t\t\t\t\t")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0af99802","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Info.vue
// module id = 555
// module chunks = 1